import { storybookReady, cumulativeOffset } from '../../../core/js/utils'
import { loggedInPromise } from '../login/login'

let storybook, settings

(async function() {
  storybook = await storybookReady()

  settings = storybook ? {
    debug: true
  } : (window.brandPage || window.listing || {})

  initBrandPanels(document)
})()

export function initBrandPanels(element) {
  settings.debug && console.log('initBrandPanels')

  initFavouriteTogglers(element)
  initMaps(element)

  element.querySelectorAll('.BrandPanel').forEach(item => {
    if (item.matches('.BrandPanel--Link')) {
      item.removeEventListener('click', brandPanelClick)
      item.addEventListener('click', brandPanelClick)
    }
  })
}

function initFavouriteTogglers(element) {
  settings.debug && console.log('initFavouriteTogglers')
  element.querySelectorAll('.ToggleFavourite').forEach(item => {
    item.removeEventListener('click', toggleFavouriteClick)
    item.addEventListener('click', toggleFavouriteClick)
  })
}

function initMaps(element) {
  settings.debug && console.log('initMaps')
  element.querySelectorAll('.ToggleMap2').forEach(item => {
    item.removeEventListener('click', toggleMap2Click)
    item.addEventListener('click', toggleMap2Click)
  })
  element.querySelectorAll('.Map2').forEach(map => {
    map.querySelectorAll('.Zoom__Plus, .Zoom__Minus').forEach(item2 => {
      item2.removeEventListener('click', zoomClick)
      item2.addEventListener('click', zoomClick)
    })

    map.querySelectorAll('.Embed').forEach(embed => {
      let src = embed.dataset.src
      if (!src) {
        let floor = embed.closest('.Map2__Floor')
        if (floor) {
          positionTooltip(floor)
        }
        return
      }
      delete embed.dataset.src
      fetch(src, {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          Accept: 'text/html'
        }
      })
      .then(response => {
        if (response.status === 200) {
          return response.text()
        } else {
          throw new Error("Not 200 response")
        }
      })
      .then(text => {
        embed.insertAdjacentHTML('beforeend', text)

        let floor = embed.closest('.Map2__Floor')
        if (floor) {
          positionTooltip(floor)
        }
      })
    })
  })
}

const toggleFavouriteClick = (event) => {
  event.preventDefault()
  loggedInPromise().then(response => {
    if (!response) {
      return
    }

    let currentTarget = event.currentTarget
    let brandPanel = currentTarget.closest('.BrandPanel')
    let brand = brandPanel.dataset.brand
    let remove = (typeof brandPanel.dataset.favourite !== 'undefined')
    settings.debug && console.log('ToggleFavourite', brand, remove)
    if (storybook) {
      return
    }
    let query = 'favourite=true&brand=' + brand + '&remove=' + remove
    fetch(location.pathname + '?' + query, {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        Accept: 'application/json'
      }
    })
    .then(response => {
      if (response.status === 200) {
        if (response.headers.get('Content-Type').indexOf('application/json') !== -1) {
          return response.json()
        }
      } else {
        throw new Error("Not 200 response")
      }
    })
    .then(success => {
      if (success) {
        if (remove) {
          delete brandPanel.dataset.favourite
        } else {
          brandPanel.dataset.favourite = ''
        }

        if (currentTarget.dataset.tracking) {
          currentTarget.dataset.tracking = currentTarget.dataset.tracking
              .replace(remove ? /^remove\b/ : /^add\b/, remove ? 'add' : 'remove')
        }
      }
    })
  })
}

const toggleMap2Click = (event) => {
  settings.debug && console.log('toggleMap2Click')
  event.preventDefault()
  loggedInPromise().then(response => {
    if (!response) {
      return
    }
    let panel = event.target.closest('.BrandPanel')
    mapPromise(panel).then(map => {
      if (!map) {
        return
      }
      panel.classList.toggle('BrandPanel--MapShown')
      let show = panel.classList.contains('BrandPanel--MapShown')
      if (show) {
        initMaps(panel)
      }
      document.dispatchEvent(new CustomEvent('toggleMap2', {
        detail: {
          'panel': panel,
          'map': map,
          'show': show
        }
      }))
    })
  })
}

const zoomClick = (event) => {
  event.preventDefault()
  let floor = event.currentTarget.closest('.MapWrapper').querySelector('.Map2__Floor')
  let currentZoom = parseInt(floor.querySelector(".Embed").getAttribute('data-zoom-level'))
  let embed = floor.querySelector(".Embed")
  if (event.currentTarget.classList.contains('Zoom__Plus')) {
    floor.classList.add('zoom-in')
    if (currentZoom < 4)
    {
      embed.setAttribute('data-zoom-level', currentZoom + 1)
    }
  } else {
    if (currentZoom !== 0)
    {
      embed.setAttribute('data-zoom-level', currentZoom - 1)
    }
    if (currentZoom === 1) {
      floor.classList.remove('zoom-in')
    }
  }
  positionTooltip(floor)
}

function mapPromise(panel) {
  settings.debug && console.log('mapPromise')
  return new Promise((resolve) => {

    let map = panel.querySelector('.Map2')
    if (map) {
      resolve(map)
      return
    }

    fetch(location.pathname + '?map=true&brand=' + encodeURIComponent(panel.dataset.brand), {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        Accept: 'text/html'
      }
    })
    .then(response => {
      if (response.status === 200) {
        return response.text()
      } else {
        throw new Error("Not 200 response")
      }
    })
    .then(text => {
      panel.insertAdjacentHTML('beforeend', text)
      map = panel.querySelector('.Map2')
      resolve(map)
    })

  })
}

const brandPanelClick = (event) => {
  if (event.target.matches('a') || event.target.closest('a')) {
    return
  }

  settings.debug && console.log('brandPanelClick')
  event.preventDefault()
  event.currentTarget.querySelector('.BrandPanel__Title a').click()
}

function positionTooltip(element) {
  settings.debug && console.log('positionTooltip')
  let stand = element.querySelector('[data-selezionato="stand"]')
  let tooltip = element.querySelector('.Map2__Tooltip')
  if (stand && tooltip) {
    let rect = stand.getBoundingClientRect()
    let offset = cumulativeOffset(element)
    settings.debug && console.log('rect', rect, 'offset', offset)

    tooltip.style.display = 'block'
    tooltip.style.left = (window.pageXOffset - offset.left + rect.left - (rect.left - rect.right) / 2 - 24) + 'px'
    tooltip.style.top = (window.pageYOffset - offset.top + rect.top - tooltip.clientHeight - 8) + 'px'
  }
}
